export default {
    canceled: 'Canceled',
    completed: 'Completed',
    confirmed: 'Confirmed',
    noShow: 'No show',
    uncompleted: 'Not completed',
};
